import { css } from 'lit';

export default css`
  :host {
    --_direction-color: var(--sl-color-foreground-disabled);
    --_gap: 0.5rem;

    cursor: pointer;
    display: inline-flex;
    gap: var(--_gap);
  }

  :host([direction]) {
    --_direction-color: var(--sl-color-foreground-plain);
  }

  .direction {
    align-items: center;
    display: inline-flex;
  }

  sl-icon {
    color: var(--_direction-color);
  }
`;
